import { useAppSelector } from '../redux/config/store';

export default function useStats() {
	const stats = useAppSelector(state => state.statistics);

	return {
		...stats,
	};
}